import * as React from "react";
import { FirstStep } from "./FirstStep";
import { SecondStep } from "./SecondStep";
import { ThirdStep } from "./ThirdStep";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MainLayout } from "../Components/MainLayout";

const InsuranceSteps = () => {
  const steps = ["مرحله اول", "مرحله دوم", "مرحله سوم"];
  const [complete, setComplete] = useState(false);
  const [activeStep, setActiveStep] = useState(1);
  const [insuranceId, setInsuranceId] = useState(null);
  const [validate, setValidate] = useState(false);
  const stepIcons = [
    <FontAwesomeIcon icon="user" />, // Icon for Step 1

    <FontAwesomeIcon icon="truck" />, // Icon for Step 2
    <FontAwesomeIcon icon="wallet" />, // Icon for Step 3
    // Add more icons for additional steps as needed
  ];
  const handleNext = (insuranceid) => {
    if (insuranceid) {
      setInsuranceId(insuranceid);
    }
    setTimeout(() => {
      setActiveStep((prev) => prev + 1);
    }, 0);
  };
  // const handlePrev = () => {
  //   setCurrentStep((prev) => prev - 1);
  // };
  const handleFinish = () => {
    setComplete(true);
  };
  const handleStepChange = (step) => {
    setValidate(true)
    setTimeout(() => {
      setValidate(false)
    },1)
    setActiveStep(step);
  };
  return (
    <div className="card wd-50  wm-100 mx-auto ">
      <div className="card-body">
        <p className="fs-4 fw-bold text-center">فرم بیمه نامه</p>
        <hr />

        <div className="multi-step  ">
          <ul className="multi-step-list ">
            {steps?.map((step, i) => (
              <li
                key={i}
                className={`multi-step-item active-profile  ${
                  activeStep === i + 1 && " current"
                }   ${(i + 1 < activeStep || complete) && "complete"} `}
                // onClick={() => handleStepChange(i + 1)}
                id="libasic"
              >

                <div className="item-wrap cursor-pointer">
                  <p className="item-title"> {step}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
        <div className="col-12">
          <div className="form-example-wrap mg-t-30">
            <div className="form-example-int form-horizental">
              <div className="form-group">
                {activeStep === 1 && (
                  <FirstStep
                    onNext={(insuranceid) => handleNext(insuranceid)} 
                    validate={validate}
                  />
                )}
                {activeStep === 2 && (
                  <SecondStep
                    insuranceId={insuranceId}
                    onNext={() => handleNext()}
                    validate={validate}
                  />
                )}
                {activeStep === 3 && (
                  <ThirdStep
                    insuranceId={insuranceId}
                    onNext={() => handleNext()}
                    validate={validate}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default () => <MainLayout children={<InsuranceSteps />} />;
